module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('sub-tabs', {
    attrs: {
      "nomeSessao": "Negócios"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c20df86c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/negocios/index.vue
// module id = 773
// module chunks = 26